<ng-select
  [items]="members"
  bindLabel="displayName"
  [addTag]="true"
  [multiple]="false"
  [hideSelected]="true"
  [trackByFn]="trackByFn"
  [minTermLength]="2"
  [loading]="membersLoading"
  [typeToSearchText]="typeToSearchText"
  (search)="membersInput$.next($event.term)"
  [(ngModel)]="selectedMembers"
  groupBy="type"
  (change)="memberChanged($event)"
  [placeholder]="placeholder"
  [readonly]="disabled"
>
<ng-template ng-label-tmp ng-option-tmp let-item="item">
  <div class="px-2" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="12px">
    <topo-avatar [name]="item?.displayName || item?.emailAddress" [imageUrl]="item?.profilePhotoUrl"></topo-avatar>
    <div>
      <div fxLayout="row">
        <div class="has-text-weight-semibold">{{ item?.displayName }}</div>
      </div>
    </div>
  </div>
</ng-template>
</ng-select>
